import { render } from "./responsiveTables.vue?vue&type=template&id=5c4b0d14"
import script from "./responsiveTables.vue?vue&type=script&lang=js"
export * from "./responsiveTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__